module.exports = __webpack_public_path__ + "img/img_ysjg.58a04cc1.jpg";